import React from 'react';
import { ChevronRight, ShieldCheck, Zap, Award } from 'lucide-react';

interface RulesStepProps {
  onNext: () => void;
}

const RulesStep: React.FC<RulesStepProps> = ({ onNext }) => {
  return (
    <div className="h-full flex flex-col text-center animate-fade-in relative">
      {/* Scrollable Content */}
      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto px-4 py-2 custom-scrollbar pb-24 md:pb-6">
        <div className="animate-slide-up mt-4 md:mt-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800">Quy tắc tham gia</h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-sm sm:text-lg mt-2 md:mt-3 px-2">
            Để đảm bảo thử thách diễn ra một cách công bằng và thành công, vui lòng lưu ý một số quy tắc sau:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6 max-w-5xl mx-auto text-left mt-6 md:mt-10 px-2 md:px-6">
          <div className="flex md:flex-col items-start gap-4 p-4 md:p-6 rounded-2xl md:rounded-3xl bg-white/60 backdrop-blur-md border border-white/50 shadow-sm hover:bg-white/80 transition-all hover:shadow-md animate-slide-up [animation-delay:100ms] h-full">
            <div className="w-10 h-10 md:w-14 md:h-14 bg-orange-100/80 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0 text-orange-600 shadow-sm">
              <Zap className="w-5 h-5 md:w-7 md:h-7" />
            </div>
            <div>
              <h3 className="text-base md:text-lg font-bold text-slate-800">Hoạt động hợp lệ</h3>
              <ul className="text-xs md:text-sm text-slate-600 mt-0.5 md:mt-2 leading-relaxed list-disc list-inside space-y-1">
                <li><span className="font-semibold">Điện thoại:</span> Run/Ride có GPS</li>
                <li><span className="font-semibold">Smartwatch:</span> Có GPS hoặc nhịp tim + ảnh</li>
              </ul>
            </div>
          </div>

          <div className="flex md:flex-col items-start gap-4 p-4 md:p-6 rounded-2xl md:rounded-3xl bg-white/60 backdrop-blur-md border border-white/50 shadow-sm hover:bg-white/80 transition-all hover:shadow-md animate-slide-up [animation-delay:100ms] h-full">
            <div className="w-10 h-10 md:w-14 md:h-14 bg-blue-100/80 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0 text-blue-600 shadow-sm">
              <Award className="w-5 h-5 md:w-7 md:h-7" />
            </div>
            <div>
              <h3 className="text-base md:text-lg font-bold text-slate-800">Quy đổi điểm</h3>
              <ul className="text-xs md:text-sm text-slate-600 mt-0.5 md:mt-2 leading-relaxed list-disc list-inside space-y-1">
                <li><span className="font-semibold">Run:</span> 1km = 1 km quy đổi</li>
                <li><span className="font-semibold">Ride:</span> 3km = 1 km quy đổi</li>
                <li><span className="font-semibold">Swim:</span> 200m = 1 km quy đổi</li>
              </ul>
            </div>
          </div>

          <div className="flex md:flex-col items-start gap-4 p-4 md:p-6 rounded-2xl md:rounded-3xl bg-white/60 backdrop-blur-md border border-white/50 shadow-sm hover:bg-white/80 transition-all hover:shadow-md animate-slide-up [animation-delay:100ms] h-full">
            <div className="w-10 h-10 md:w-14 md:h-14 bg-red-100/80 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0 text-red-600 shadow-sm">
              <ShieldCheck className="w-5 h-5 md:w-7 md:h-7" />
            </div>
            <div>
              <h3 className="text-base md:text-lg font-bold text-slate-800">Hệ thống kiểm duyệt</h3>
              <ul className="text-xs md:text-sm text-slate-600 mt-0.5 md:mt-2 leading-relaxed list-disc list-inside space-y-1">
                <li>Gắn cảnh báo hoạt động bất thường</li>
                <li>Admin có thể yêu cầu bổ sung hình ảnh</li>
                <li>Quyết định cuối cùng về tính hợp lệ thuộc về BTC</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Sticky Footer */}
      <div className="flex-none p-4 w-full bg-white/80 backdrop-blur-md border-t border-slate-100 md:bg-transparent md:border-none z-10 animate-slide-up [animation-delay:200ms] md:p-8">
        <button
          onClick={onNext}
          className="w-full max-w-md mx-auto bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-6 rounded-xl shadow-lg shadow-indigo-500/30 transition-all transform hover:-translate-y-1 active:scale-95 flex items-center justify-center gap-2 group"
        >
          Đã hiểu, tiếp tục
          <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </button>
      </div>
    </div>
  );
};

export default RulesStep;
